import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
Swiper.use([ Navigation ]);

export default class RelatedArticles {
    constructor() {
        if ($('.js-related-articles').length) {
            const $slider = $('.js-related-articles');

            const relatedArticles = new Swiper($slider[0], {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerGroup: 1,
                slidesPerView: 1,
                breakpoints: {
                    768: {
                        slidesPerGroup: 2,
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerGroup: 3,
                        slidesPerView: 3,
                        spaceBetween: 20
                    }
                }
            });

            relatedArticles.init();
        };
    };
};
